import { addDays, isValid, isWithinInterval } from 'date-fns';
import { ListViewProduct } from 'models/ListViewProduct';

export const productToCopyEvent = ({ title, articleGroup, productId, price }: ListViewProduct) => ({
  event: 'CopyContentEvent',
  eventCategory: 'ProductCard',
  eventValue: `${title}--
    ${productId}--
    ${articleGroup}--
    ${price.listPrice}`
});

const INTERVAL_DAYS = 2;

export const showCampaignCountDownTimer = (campaignEnd?: Date) => {
  if (!campaignEnd) {
    return false;
  }
  const now = Date.now();
  const date = new Date(campaignEnd);
  return (
    date &&
    isValid(date) &&
    isWithinInterval(date, {
      start: now,
      end: addDays(now, INTERVAL_DAYS)
    })
  );
};
